import React from "react";
import { Modal, Button } from "react-bootstrap";
import ViewCategory from "./ViewCategory";

const CategoryViewModal = ({ show, onHide, categoryId }) => {
    return (
        <Modal show={show} onHide={onHide} size="lg" centered scrollable dialogClassName="catalog-modal">
            <Modal.Header closeButton>
                <Modal.Title>Category Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ViewCategory categoryId={categoryId} />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CategoryViewModal;
